module.exports = __webpack_public_path__ + "static/media/Jignesh_Mohanty.jpg:Zone.386d52fd.Identifier";